// What a display's HELP code says about it, read from the page's query string
// (the Trident OLED's SETUP > HELP, firmware 1.0.6+). Every field is checked
// here: anyone can make a tanksensei.com link with any query, and the address
// becomes a link the keeper is told to type the display's PIN into, so only a
// home-network address (10/8, 172.16/12, 192.168/16, 169.254/16) is taken.
// The code carries no display id: that is part of the pairing code.

const IPV4 = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

export function isHomeNetworkAddress(ip) {
  if (typeof ip !== 'string' || !IPV4.test(ip)) return false;
  const [a, b] = ip.split('.').map(Number);
  return (
    a === 10 ||
    (a === 172 && b >= 16 && b <= 31) ||
    (a === 192 && b === 168) ||
    (a === 169 && b === 254)
  );
}

function int(v) {
  if (typeof v !== 'string' || !/^-?\d{1,6}$/.test(v)) return null;
  return Number(v);
}

export function readDeviceHelp(search) {
  const q = new URLSearchParams(search || '');
  const str = (k, re) => {
    const v = q.get(k);
    return typeof v === 'string' && re.test(v) ? v : null;
  };
  const ip = isHomeNetworkAddress(q.get('i')) ? q.get('i') : null;
  return {
    kind: q.get('t') === 'trident' ? 'trident' : null,
    firmware: str('v', /^[0-9A-Za-z.-]{1,20}$/),
    wifiUp: q.get('w') === '1' ? true : q.get('w') === '0' ? false : null,
    wifiReason: int(q.get('r')),
    apexCode: int(q.get('a')),
    apexSearch: int(q.get('f')),
    cloud: int(q.get('c')),
    linked: q.get('k') === '1' ? true : q.get('k') === '0' ? false : null,
    ip,
    settingsUrl: ip ? `http://${ip}/` : null,
  };
}

// The same reason codes the display turns into words (pr_wifi_problem).
export function wifiProblem(reason) {
  if ([2, 15, 202, 204].includes(reason)) return 'password';
  if ([201, 210, 211, 212].includes(reason)) return 'not_found';
  return 'other';
}

// The problems to show, worst first. Wi-Fi first: without it nothing else
// can be judged. A help page opened with no display fields (from the link
// page's "Get help") shows only the general steps.
export function deviceHelpIssues(h) {
  if (!h || h.kind !== 'trident') return [];
  const out = [];
  if (h.wifiUp === false) {
    out.push({ key: 'wifi', problem: wifiProblem(h.wifiReason) });
    return out;
  }
  if (h.apexSearch === 2) out.push({ key: 'apex_not_found' });
  else if (h.apexSearch === 1) out.push({ key: 'apex_searching' });
  else if (h.apexCode === 401) out.push({ key: 'apex_login' });
  else if (h.apexCode !== null && h.apexCode < 0) out.push({ key: 'apex_unreachable' });
  if (h.apexSearch === 3) out.push({ key: 'apex_many' });
  if (h.cloud === 0 || h.cloud === 1) out.push({ key: 'cloud' });
  if (h.linked === false) out.push({ key: 'not_linked' });
  return out;
}

// The facts sent with a help request, in words support can read.
export function deviceHelpSummary(h) {
  if (!h || h.kind !== 'trident') return '';
  const yes = (v, a, b) => (v === true ? a : v === false ? b : 'unknown');
  const lines = [
    'Display: Trident OLED',
    h.firmware ? `Firmware: ${h.firmware}` : null,
    `Wi-Fi: ${yes(h.wifiUp, 'connected', 'not connected')}${
      h.wifiReason ? ` (last reason ${h.wifiReason})` : ''
    }`,
    h.apexCode !== null ? `Apex reply: ${h.apexCode}` : null,
    h.apexSearch !== null
      ? `Apex search: ${['set', 'searching', 'not found', 'more than one'][h.apexSearch] || h.apexSearch}`
      : null,
    h.cloud !== null
      ? `TankSensei connection: ${['off', 'connecting', 'online'][h.cloud] || h.cloud}`
      : null,
    `Linked: ${yes(h.linked, 'yes', 'no')}`,
    h.ip ? `Address: ${h.ip}` : null,
  ];
  return lines.filter(Boolean).join('\n');
}
